import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { MachineFixing } from "../../interfaces/api/MachineFixing";
import { Rototilt } from "../../interfaces/api/Rototilt";
import { MachineFixingType } from "../../shared/enums/MachineFixingType";
import { ProductCategory } from "../../shared/enums/ProductCategory";
import TooltipPopup from "../shared/TooltipPopup";
import MachineFixings from "./MachineFixings";

interface MachineFixingsOptionalProps {
  isAccordianExpanded: boolean;
  machineFixnings: MachineFixing[];
  onAccordianClick(): void;
  onMachineFixingChange(machineFixing: MachineFixing): void;
  onMachineFixingTypeChange(machineFixingType: MachineFixingType): void;
  productCategory: ProductCategory;
  selectedMachineFixing: MachineFixing;
  selectedMachineFixingType: MachineFixingType;
  selectedTiltrotator: Rototilt;
}

const MachineFixingsOptional = ({
  isAccordianExpanded,
  machineFixnings,
  onAccordianClick,
  onMachineFixingChange,
  onMachineFixingTypeChange,
  productCategory,
  selectedMachineFixing,
  selectedTiltrotator,
  selectedMachineFixingType,
}: MachineFixingsOptionalProps) => {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onGrappleModuleChangeDummy = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onNoneGrapppleModuleChangeDummy = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onLowerBracketChangeDummy = () => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onUpperBracketChangeDummy = () => {};
  const tooltopMachinefixing = "machineFixingTooltipId";

  const { t } = useTranslation(["machinefixings"]);
  const infoTooltip =
    t("sfixing.sfixing") +
    "\n" +
    t("sfixing.infotext") +
    "\n\n" +
    t("qcfixing.qcfixing") +
    "\n" +
    t("qcfixing.infotext") +
    "\n\n" +
    t("directmount.directmount") +
    "\n" +
    t("directmount.infotext");
  return (
    <Accordion elevation={0} expanded={isAccordianExpanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel-tools-content"
        id="panel-tools-header"
        onClick={onAccordianClick}
      >
        <div className="toolOptionalHeader">
          <Checkbox checked={isAccordianExpanded} />
          <h3>{t("choosemachinefixing")}</h3>
          <TooltipPopup text={infoTooltip} id={tooltopMachinefixing} />
        </div>
      </AccordionSummary>
      <AccordionDetails>
        <MachineFixings
          machineFixings={machineFixnings}
          onGrappleModuleChange={onGrappleModuleChangeDummy}
          onLowerBracketChange={onLowerBracketChangeDummy}
          onMachineFixingChange={onMachineFixingChange}
          onMachineFixingTypeChange={onMachineFixingTypeChange}
          onNoneGrapppleModuleChange={onNoneGrapppleModuleChangeDummy}
          onUpperBracketChange={onUpperBracketChangeDummy}
          productCategory={productCategory}
          refGrappleModules={undefined}
          refLowerBrackets={undefined}
          refMachineFixingList={undefined}
          refMachineFixings={undefined}
          refUpperBrackets={undefined}
          selectedMachineFixing={selectedMachineFixing}
          selectedTiltrotator ={selectedTiltrotator}
          selectedMachineFixingType={selectedMachineFixingType}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default MachineFixingsOptional;
